import { render, staticRenderFns } from "./PaymentsOverviewWidget.vue?vue&type=template&id=38b05fc3&"
import script from "./PaymentsOverviewWidget.vue?vue&type=script&lang=js&"
export * from "./PaymentsOverviewWidget.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsOverviewWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports